var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mIndex"},[_c('Header'),_c('NavBar',{attrs:{"addRouterList":_vm.addRouterList}}),_c('div',{staticClass:"main"},[_c('router-view',{key:_vm.$route.name})],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }